<template>
  <div>
    <div class="inputCard w3-margin-bottom">
      <header class="pointer" @click="toggleAccordion()" :style="accordion.slider ? '' : 'border-radius:5px 5px 5px 5px'"><i class="mr-2 fa w3-small" :class="accordion.slider ? 'fa-chevron-down' : 'fa-chevron-right'"></i>Home Page Slider</header>
      <div class="content" v-if="accordion.slider">
        <div class="cardRow w3-padding-8">
          <label>Enabled</label>
          <div class="w3-right-align">
            <label class="switch">
              <input type="checkbox" v-model="state.siteData.pages.home.sections.slider.enabled">
              <span class="slider"></span>
            </label>
          </div>
        </div>
        <template v-if="state.siteData.pages.home.sections.slider.enabled">
          <div class="cardRow w3-padding-8">
            <label>Slider Type</label>
            <select class="w3-select w3-border" v-model="state.siteData.pages.home.sections.slider.type">
              <option value="classic">Classic</option>
              <option value="quote">Quote Form</option>
              <option value="full-screen-buttons">Full Screen w/ buttons</option>
              <option value="app">Mobile App</option>
            </select>
          </div>
        </template>

        <template v-if="state.siteData.pages.home.sections.slider.enabled">
          <template v-if="state.siteData.pages.home.sections.slider.type === 'quote'">
            <div class="inputCard w3-margin-bottom">
              <header>Slide 1</header>
              <div class="cardRow w3-padding-8" style="border-bottom:0;">
                <label style="margin-top:6px;">Slider Background (1920x654)</label>
                <div class="w3-right-align">
                  <label for="file1" class="w3-button w3-green w3-small" style="margin-top:0;">Upload Image</label>
                  <input id="file1" type="file" @change="uploadSlide($event.target.files, 1)" ref="slide1FileUpload" accept=".png,.jpg,.jpeg" class="inputFile" />
                </div>
              </div>
              <div class="w3-center w3-border-bottom w3-padding-bottom">
                <img v-if="state.siteData.pages.home.sections.slider.slide1.src !== ''" :src="state.siteData.pages.home.sections.slider.slide1.src" style="width:100%; max-width:300px;" />
              </div>
              <div class="cardRow w3-padding-8 w3-border-bottom">
                <label>Overlay (darken)</label>
                <div class="w3-right-align">
                  <label class="switch">
                    <input type="checkbox" v-model="state.siteData.pages.home.sections.slider.slide1.overlay">
                    <span class="slider"></span>
                  </label>
                </div>
              </div>
              <div class="cardRow w3-padding-8 w3-border-bottom">
                <label>Quote Form Color</label>
                <div class="w3-right-align">
                  <select class="w3-select w3-border" v-model="state.siteData.pages.home.sections.slider.quoteBG">
                    <option value="primary">Primary</option>
                    <option value="light">Light</option>
                    <option value="dark">Dark</option>
                  </select>
                </div>
              </div>
              <div class="cardRow w3-padding-8 w3-border-bottom">
                <label>Line 1 Text</label>
                <input v-model="state.siteData.pages.home.sections.slider.slide1.line1text" placeholder="AFFORDABLE QUALITY" class="w3-input w3-border" />
              </div>
              <div class="cardRow w3-padding-8 w3-border-bottom">
                <label>Line 2 Text</label>
                <input v-model="state.siteData.pages.home.sections.slider.slide1.line2text" placeholder="NEW WEBSITE" class="w3-input w3-border" />
              </div>
              <div class="cardRow w3-padding-8">
                <label>Line 3 Text</label>
                <input v-model="state.siteData.pages.home.sections.slider.slide1.line3text" placeholder="Starting as low as $59 per month" class="w3-input w3-border" />
              </div>
            </div>
          </template>
          <template v-if="state.siteData.pages.home.sections.slider.type === 'full-screen-buttons'">
            <div v-for="(slide, key, index) in slides" :key="index">
              <template v-if="key !== 'enabled' && key !== 'type'">
                <div class="subHeader">Slide {{index+1}}</div>
                <div class="cardRow w3-padding-8" style="border-bottom:0;">
                  <label style="margin-top:6px;">Slider Background (1920x654)</label>
                  <div class="w3-right-align">
                    <label :for="'file' + index+1" class="w3-button w3-green w3-small" style="margin-top:0;">Upload Image</label>
                    <input :id="'file' + index+1" type="file" @change="uploadSlide($event.target.files, index+1)" :ref="'slide' + index+1 + 'FileUpload'" accept=".png,.jpg,.jpeg" class="inputFile" />
                  </div>
                </div>
                <div class="w3-center w3-border-bottom w3-padding-bottom">
                  <img v-if="state.siteData.pages.home.sections.slider[key].src !== ''" :src="state.siteData.pages.home.sections.slider[key].src" style="width:100%; max-width:300px;" />
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom">
                  <label>Line 1 Text</label>
                  <input v-model="state.siteData.pages.home.sections.slider[key].line1text" placeholder="AFFORDABLE QUALITY" class="w3-input w3-border" />
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom">
                  <label>Line 2 Text</label>
                  <input v-model="state.siteData.pages.home.sections.slider[key].line2text" placeholder="NEW WEBSITE" class="w3-input w3-border" />
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom">
                  <label>Line 3 Text</label>
                  <input v-model="state.siteData.pages.home.sections.slider[key].line3text" placeholder="Starting as low as $59 per month" class="w3-input w3-border" />
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom">
                  <label>Button 1 Enabled</label>
                  <div class="w3-right-align">
                    <label class="switch">
                      <input type="checkbox" v-model="state.siteData.pages.home.sections.slider[key].button1enabled">
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom" v-if="state.siteData.pages.home.sections.slider[key].button1enabled">
                  <label>Button 1 Text</label>
                  <input v-model="state.siteData.pages.home.sections.slider[key].button1text" placeholder="LEARN MORE" class="w3-input w3-border" />
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom" v-if="state.siteData.pages.home.sections.slider[key].button1enabled">
                  <label>Button 1 URL</label>
                  <input v-model="state.siteData.pages.home.sections.slider[key].button1url" placeholder="about-us.php" class="w3-input w3-border" />
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom">
                  <label>Button 2 Enabled</label>
                  <div class="w3-right-align">
                    <label class="switch">
                      <input type="checkbox" v-model="state.siteData.pages.home.sections.slider[key].button2enabled">
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom" v-if="state.siteData.pages.home.sections.slider[key].button2enabled">
                  <label>Button 2 Text</label>
                  <input v-model="state.siteData.pages.home.sections.slider[key].button2text" placeholder="LEARN MORE" class="w3-input w3-border" />
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom" v-if="state.siteData.pages.home.sections.slider[key].button2enabled">
                  <label>Button 2 URL</label>
                  <input v-model="state.siteData.pages.home.sections.slider[key].button2url" placeholder="about-us.php" class="w3-input w3-border" />
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom">
                  <label>Button 3 Enabled</label>
                  <div class="w3-right-align">
                    <label class="switch">
                      <input type="checkbox" v-model="state.siteData.pages.home.sections.slider[key].button3enabled">
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom" v-if="state.siteData.pages.home.sections.slider[key].button3enabled">
                  <label>Button 3 Text</label>
                  <input v-model="state.siteData.pages.home.sections.slider[key].button3text" placeholder="LEARN MORE" class="w3-input w3-border" />
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom" v-if="state.siteData.pages.home.sections.slider[key].button3enabled">
                  <label>Button 3 URL</label>
                  <input v-model="state.siteData.pages.home.sections.slider[key].button3url" placeholder="about-us.php" class="w3-input w3-border" />
                </div>
              </template>
            </div>
          </template>
          <template v-if="state.siteData.pages.home.sections.slider.type === 'classic'">
            <div class="inputCard w3-margin-bottom" v-for="(slide, key, index) in slides" :key="index">
              <header>Slide {{index+1}}</header>
              <div class="content">
                <div class="cardRow w3-padding-8" style="border-bottom:0;">
                  <label style="margin-top:6px;">Slider Background (1920x654)</label>
                  <div class="w3-right-align">
                    <label :for="'file' + index+1" class="w3-button w3-green w3-small" style="margin-top:0;">Upload Image</label>
                    <input :id="'file' + index+1" type="file" @change="uploadSlide($event.target.files, index+1)" :ref="'slide' + index+1 + 'FileUpload'" accept=".png,.jpg" class="inputFile" />
                  </div>
                </div>
                <div class="w3-center w3-border-bottom w3-padding-bottom">
                  <img v-if="state.siteData.pages.home.sections.slider[key].src !== ''" :src="state.siteData.pages.home.sections.slider[key].src" style="width:100%; max-width:300px;" />
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom">
                  <label>Overlay (darken)</label>
                  <div class="w3-right-align">
                    <label class="switch">
                      <input type="checkbox" v-model="state.siteData.pages.home.sections.slider[key].overlay">
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom">
                  <label>Text Align</label>
                  <select class="w3-select w3-border" v-model="state.siteData.pages.home.sections.slider[key].align">
                    <option value="center">Center</option>
                    <option value="left">Left</option>
                    <option value="right">Right</option>
                  </select>
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom">
                  <label>Line 1 Text</label>
                  <input v-model="state.siteData.pages.home.sections.slider[key].line1text" placeholder="AFFORDABLE QUALITY" class="w3-input w3-border" />
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom">
                  <label>Line 2 Text</label>
                  <input v-model="state.siteData.pages.home.sections.slider[key].line2text" placeholder="NEW WEBSITE" class="w3-input w3-border" />
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom">
                  <label>Line 3 Text</label>
                  <input v-model="state.siteData.pages.home.sections.slider[key].line3text" placeholder="Starting as low as $59 per month" class="w3-input w3-border" />
                </div>
              </div>
            </div>
          </template>
          <template v-if="state.siteData.pages.home.sections.slider.type === 'app'">
            <div class="inputCard w3-margin-bottom">
              <header>Mobile App Slider Main</header>
              <div class="content">
                <div class="cardRow w3-padding-8 w3-border-bottom">
                  <label>Overlay (darken)</label>
                  <!-- <div class="w3-right-align">
                    <label class="switch">
                      <input type="checkbox" v-model="state.siteData.pages.home.sections.slider[0].overlay">
                      <span class="slider"></span>
                    </label>
                  </div> -->
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom">
                  <label>Text Align</label>
                  <!-- <select class="w3-select w3-border" v-model="state.siteData.pages.home.sections.slider[0].align">
                    <option value="center">Center</option>
                    <option value="left">Left</option>
                    <option value="right">Right</option>
                  </select> -->
                </div>
              </div>
            </div>
            <!-- <div class="inputCard w3-margin-bottom" v-for="(slide, key, index) in slides" :key="index">
              <header>Slide {{index+1}}</header>
              <div class="content">
                <div class="cardRow w3-padding-8" style="border-bottom:0;">
                  <label style="margin-top:6px;">Slider Background (1920x654)</label>
                  <div class="w3-right-align">
                    <label :for="'file' + index+1" class="w3-button w3-green w3-small" style="margin-top:0;">Upload Image</label>
                    <input :id="'file' + index+1" type="file" @change="uploadSlide($event.target.files, index+1)" :ref="'slide' + index+1 + 'FileUpload'" accept=".png,.jpg" class="inputFile" />
                  </div>
                </div>
                <div class="w3-center w3-border-bottom w3-padding-bottom">
                  <img v-if="state.siteData.pages.home.sections.slider[key].src !== ''" :src="state.siteData.pages.home.sections.slider[key].src" style="width:100%; max-width:300px;" />
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom">
                  <label>Overlay (darken)</label>
                  <div class="w3-right-align">
                    <label class="switch">
                      <input type="checkbox" v-model="state.siteData.pages.home.sections.slider[key].overlay">
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom">
                  <label>Text Align</label>
                  <select class="w3-select w3-border" v-model="state.siteData.pages.home.sections.slider[key].align">
                    <option value="center">Center</option>
                    <option value="left">Left</option>
                    <option value="right">Right</option>
                  </select>
                </div>
              </div>
            </div> -->
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
var dataStore = require('@/dataStore').default

export default {
  name: 'cmsslider',
  data() {
    return {
      state: dataStore.state
    }
  },
  props: {
    accordion: Object
  },
  computed: {
    slides: function() {
      let slides = {}
      for (let key of Object.keys(this.state.siteData.pages.home.sections.slider)) {
        if (key !== 'enabled' && key !== 'quoteBG' && key !== 'type') {
          slides[key] = this.state.siteData.pages.home.sections.slider[key]
        }
      }
      return slides
    }
  },
  methods: {
    uploadSlide(files, slideNum) {
      dataStore.uploadImage(files).then((path) => {
        this.state.siteData.pages.home.sections.slider['slide' + slideNum].src = path
        // console.log('slide' + slideNum)
        // console.log(this.state.siteData.pages.home.sections.slider['slide' + slideNum].src)
      })
    },
    toggleAccordion() {
      this.$emit('toggleAccordion', !this.accordion.slider)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cms/pages/home/cmsSlider.vue